import { io, Socket } from 'socket.io-client';

// ===================================================================
// SocketService — dünner Singleton um socket.io-client (2026-08-27).
// Nutzt das bestehende Channel-Modell des Backends
// (websocket-service.js: 'subscribe' / 'unsubscribe' Events).
// Verbindung wird lazy aufgebaut (erst wenn ein Feature sie braucht)
// und nach Reconnects werden alle Channels automatisch re-subscribed.
// ===================================================================

const API_BASE_URL = (process.env.REACT_APP_API_URL || 'http://localhost:3001').replace(/\/+$/, '');

class SocketService {
  private socket: Socket | null = null;
  private subscribedChannels = new Set<string>();

  private ensureConnected(): Socket {
    if (!this.socket) {
      this.socket = io(API_BASE_URL, {
        transports: ['websocket', 'polling'],
        reconnectionAttempts: Infinity,
        reconnectionDelay: 2000,
        reconnectionDelayMax: 10000,
      });
      this.socket.on('connect', () => {
        // Nach (Re-)Connect alle aktiven Channels erneut subscriben
        this.subscribedChannels.forEach((channel) => {
          this.socket?.emit('subscribe', channel);
        });
      });
    }
    return this.socket;
  }

  /** Channel abonnieren (mehrfach-sicher) */
  subscribe(channel: string): void {
    const socket = this.ensureConnected();
    if (!this.subscribedChannels.has(channel)) {
      this.subscribedChannels.add(channel);
      if (socket.connected) socket.emit('subscribe', channel);
    }
  }

  /** Channel abbestellen */
  unsubscribe(channel: string): void {
    if (!this.subscribedChannels.delete(channel)) return;
    if (this.socket?.connected) this.socket.emit('unsubscribe', channel);
  }

  /** Event-Listener registrieren (Rückgabe: Unsubscribe-Funktion) */
  on<T = any>(event: string, callback: (data: T) => void): () => void {
    const socket = this.ensureConnected();
    socket.on(event, callback);
    return () => socket.off(event, callback);
  }
}

const socketService = new SocketService();
export default socketService;
